import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { ArrowLeft, ShieldCheck, MapPin, Clock, Users } from 'lucide-react';
import { BrandLogo } from './BrandLogo';

const AboutUsPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="bg-white border-b sticky top-0 z-10">
        <div className="container mx-auto px-4 py-4 flex items-center gap-4">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} data-testid="about-back-btn">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <BrandLogo variant="compact" className="h-8 w-auto" />
          <h1 className="text-xl font-bold border-l pl-4">About Us</h1>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8 max-w-3xl space-y-6">
        <Card className="p-8">
          <h2 className="text-2xl font-bold mb-3">Who We Are</h2>
          <p className="text-muted-foreground leading-relaxed">
            BookMyDriver is a service by V8 Technologies Private Limited that connects car owners with
            verified, professional drivers on an hourly basis. Whether it is a city tour, a shopping trip,
            a late-night pickup, or a long drive you would rather not do yourself, we bring the driver to
            your car, so you always travel in the vehicle you trust.
          </p>
        </Card>

        <div className="grid sm:grid-cols-2 gap-4">
          <Card className="p-6">
            <ShieldCheck className="w-8 h-8 text-primary mb-3" />
            <h3 className="font-semibold mb-1">Verified Drivers</h3>
            <p className="text-sm text-muted-foreground">Every driver's identity, Aadhaar, and license are verified before they go live.</p>
          </Card>
          <Card className="p-6">
            <MapPin className="w-8 h-8 text-primary mb-3" />
            <h3 className="font-semibold mb-1">Live Tracking</h3>
            <p className="text-sm text-muted-foreground">Track your driver's location in real time from booking to drop-off.</p>
          </Card>
          <Card className="p-6">
            <Clock className="w-8 h-8 text-primary mb-3" />
            <h3 className="font-semibold mb-1">Hourly, No Surprises</h3>
            <p className="text-sm text-muted-foreground">Transparent hourly pricing from 1 to 8 hours, you always know the fare upfront.</p>
          </Card>
          <Card className="p-6">
            <Users className="w-8 h-8 text-primary mb-3" />
            <h3 className="font-semibold mb-1">Built for Everyone</h3>
            <p className="text-sm text-muted-foreground">Request a female driver, share a trip PIN for safety, and reach support anytime.</p>
          </Card>
        </div>

        <Card className="p-8 text-center bg-primary-dark text-white">
          <p className="text-white/90">© 2026 V8 Technologies Private Limited | BookMyDriver.in | All Rights Reserved.</p>
        </Card>
      </div>
    </div>
  );
};

export default AboutUsPage;
